import React from 'react'
import { Col, Row } from 'react-bootstrap';
import { iDeliveryLocation } from '../types';

interface DeliveryLocationProps {
    location: iDeliveryLocation;
}

const DeliveryLocation = ({location}: DeliveryLocationProps) => {
    const { firstName, lastName, address, state, email, country, phone } = location;
    return (
        <Row>
            <Col xs={12}>
                <p className='px-3 m-0'><strong>{ firstName } { lastName }</strong></p>
                <p className='px-3 m-0'>{ address }</p>
                <p className='px-3 m-0'>{ email }</p>
                { state && (<p className='px-3 m-0'>{ state + ", "}{ country + "." }</p>) }
                { phone && <p className='px-3 m-0'>+{ phone }</p> }
            </Col>
        </Row>
    )
}

export default DeliveryLocation
